import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

// Parsing a string with an explicit format, e.g. dayjs('09:00 AM', 'hh:mm A')
dayjs.extend(customParseFormat)

export default dayjs
